export enum AssetKeys {
  Identifier = 'identifier',
  Criticality = 'criticality',
  BusinessAttributes = 'business_attributes',
}
